import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Config } from 'src/config';
import CheckoutForm from './checkoutForm';

const StripePaymentComponent = ({ clientSecret,planName, currencySymbol, amount }) => {
  const stripePromise = loadStripe(Config.Stripe.clientId);
  const appearance = {
    theme: 'stripe',
  };
  const options = {
    clientSecret,
    appearance,
  };
  return (
    <div className="stripe-payment-c">
      {clientSecret && (
        <Elements options={options} stripe={stripePromise}>
          <CheckoutForm amount={amount} currencySymbol={currencySymbol} planName={planName}/>
        </Elements>
      )}
    </div>
  );
};
export default StripePaymentComponent;
